import { generateQueryString } from "@/shared/utils";
import { useIntersectionObserver } from "@vueuse/core";
import { pathOr } from "ramda";
import { inject, onMounted, onUnmounted, ref } from "vue";

const appUtils = {
  install(app: any) {
    // provide global properties object
    const globalProperties = app.config.globalProperties;

    // generate config keys
    app.provide("generateConfig", (key: any) => {
      const config: any = inject("config");
      return pathOr("", key, config);
    });

    app.provide("generateCustom", (key: any, showDefault = true) => {
      const custom: any = inject("custom");
      return pathOr(showDefault, [key], custom);
    });

    // generate i18n language
    app.provide("generateLanguage", (...args: any) => {
      return globalProperties.$lang(...args);
    });

    // generate toast alert
    app.provide("toastAlert", (message: string, type = "success") =>
      globalProperties.$notify[type](message)
    );

    // generate api url
    app.provide(
      "generateApiUrl",
      ({
        vm = globalProperties,
        keys = [],
        replacement = [],
        queryString = {},
        extraQueryString = null,
        fullQueryString = null,
        baseUrl = ["api_url"],
      }: any = {}) => {
        const domain = pathOr("", baseUrl, vm.$config);
        const path = pathOr("", keys, vm.$config);
        let url = domain + path;
        for (const key in replacement) {
          if (Object.prototype.hasOwnProperty.call(replacement, key)) {
            // replace values
            url = url.replace(`{${key}}`, replacement[key]);
          }
        }

        if (!fullQueryString) {
          // add query strings to url when not set full query string
          url = extraQueryString
            ? generateQueryString(url, queryString) + extraQueryString
            : generateQueryString(url, queryString);
        } else {
          // when set full query string
          url += fullQueryString;
        }
        return url;
      }
    );

    // generate api url
    app.provide("lazyLoadElement", (callback: any = () => {}) => {
      const el = ref(null);
      const visited = ref(false);
      useIntersectionObserver(el, ([{ isIntersecting }]) => {
        if (!visited.value && isIntersecting) {
          visited.value = true;
          callback();
        }
      });
      return { el, visited };
    });

    // useState
    // app.provide("useState", (initialValue: any = null) => {
    //   const state = ref(initialValue);
    //   const setState = (val: any) => (state.value = val);
    //   return [state, setState];
    // });

    // useState
    app.provide("useState", (initialValue: any = null) => {
      const state = ref(initialValue);

      const setState = (valOrUpdater: any) => {
        if (typeof valOrUpdater === "function") {
          state.value = valOrUpdater(state.value);
        } else {
          state.value = valOrUpdater;
        }
      };

      return [state, setState];
    });

    // useMobile
    app.provide("useMobile", () => {
      const isMobile = ref(false);

      const checkMobile = () => {
        isMobile.value = window.innerWidth <= 1200;
      };

      onMounted(() => {
        checkMobile();
        window.addEventListener("resize", checkMobile);
      });

      onUnmounted(() => {
        window.removeEventListener("resize", checkMobile);
      });

      return { isMobile };
    });
  },
};
export default appUtils;
